import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { pricingApiConnect } from '../../../../lib/api/pricingApi.connect';
import { projectDataClient, responseDocumentClient } from '../../../../lib/connect/clients';
export function parseWorkbookMapping(raw) {
    const mapping = JSON.parse(raw);
    if (mapping.schema !== 'pricing-workbook-map/v1' || !Array.isArray(mapping.rows)) throw new Error('Unsupported workbook mapping. Find columns again.');
    return {
        ...mapping,
        protected_columns: mapping.protected_columns ?? [],
        protected_cells: mapping.protected_cells ?? [],
        unmatched_template_rows: mapping.unmatched_template_rows ?? [],
        unmatched_categories: mapping.unmatched_categories ?? [],
        unmatched_periods: mapping.unmatched_periods ?? [],
        extractor_warnings: mapping.extractor_warnings ?? []
    };
}
export function usePriceVolume(scope) {
    return useQuery({
        queryKey: [
            'pricing-evidence',
            scope.principal,
            scope.projectId,
            scope.scenarioId,
            scope.period
        ],
        enabled: !!scope.principal && !!scope.scenarioId,
        staleTime: 0,
        retry: false,
        queryFn: ()=>pricingApiConnect.listEvidence(scope.projectId, scope.scenarioId)
    });
}
export function useFillPricingWorkbook() {
    const cache = useQueryClient();
    return useMutation({
        mutationKey: [
            'pricing-write'
        ],
        retry: false,
        mutationFn: (request)=>projectDataClient.fillPricingWorkbook(request),
        onSuccess: async ()=>{
            await Promise.all([
                'pricing-evidence',
                'price-volume-metadata',
                'volumeDocuments',
                'officeWorkspace',
                'officeVersions'
            ].map((name)=>cache.invalidateQueries({
                    queryKey: [
                        name
                    ]
                })));
        }
    });
}
export function usePriceDocumentMetadata(projectId, doc, principal = '') {
    return useQuery({
        queryKey: [
            'price-volume-metadata',
            principal,
            projectId,
            doc?.volumeDocumentId
        ],
        enabled: !!doc && !!principal,
        retry: false,
        staleTime: 0,
        queryFn: async ()=>{
            if (!doc) throw new Error('Choose a spreadsheet');
            const container = {
                kind: 'volume',
                projectId,
                volumeId: doc.volumeId
            };
            const [workspace, versions] = await Promise.all([
                responseDocumentClient.getResponseWorkspace({
                    container,
                    documentId: doc.shirohigeDocumentId
                }),
                responseDocumentClient.listDocumentVersions({
                    container,
                    documentId: doc.shirohigeDocumentId,
                    pageSize: 200
                })
            ]);
            return {
                document: workspace.documents.find((d)=>d.documentId === doc.shirohigeDocumentId),
                versions: versions.versions
            };
        }
    });
}
export function parseWorkbookDiff(raw) {
    try {
        const diff = JSON.parse(raw);
        if (diff.schema !== 'pricing-diff/v2' || !Array.isArray(diff.changes)) return undefined;
        return {
            ...diff,
            informational: diff.informational ?? []
        };
    } catch  {
        return undefined;
    }
}
export function pendingWorkbookChanges(proposals = []) {
    return proposals.filter((p)=>p.status === 'PENDING').reduce((count, p)=>count + (parseWorkbookDiff(p.proposedDiffJson)?.changes.length ?? 0), 0);
}
